<template>
    <div  :class="isMobile==0?'':'fsb_mobile'"class="fsb">
        <!-- 1. 新增：悬浮翻译按钮 -->
        <!-- <div class="translate-btn" @click="toggleLang">
            {{ currentLang === 'en' ? '中文' : 'English' }}
        </div> -->

        <!-- 提交成功提示弹窗 -->
        <div class="success-tip" v-if="showSuccessTip">
            <div class="success-icon">✓</div>
            <div class="success-text">{{ langMap.successText[currentLang] }}</div>
            <div class="success-desc">{{ langMap.successDesc[currentLang] }}</div>
        </div>

        <div :class="isMobile==0?'':'fsb_box_mobile'" class="fsb_box">
            <!-- 标题（已支持翻译） -->
            <div :class="isMobile==0?'':'fsb_title_mobile'" class="fsb_title animate-fade-in">{{ langMap.title[currentLang] }}</div>
            <!-- 副标题（已支持翻译） -->
            <div :class="isMobile==0?'':'fsb_small_title_mobile'" class="fsb_small_title animate-fade-in">{{ langMap.subtitle[currentLang] }}</div>
            <!-- 表单（文本已替换为翻译映射） -->
            <form @submit.prevent="submitForm" class="fsb_form animate-fade-in">
                <!-- 1. First Name（必填） -->
                <label style="width: 380px;">{{ langMap.labels.firstName[currentLang] }}</label>
                <input 
                    class="fsb_inpu" 
                    v-model="form.firstName" 
                    type="text" 
                    :class="{ error: errors.firstName }"
                    @input="clearError('firstName')"
                    :placeholder="langMap.placeholders.firstName[currentLang]"
                />
                <div class="error-tip" v-if="errors.firstName">{{ langMap.tips.pleaseWrite[currentLang] }}</div>

                <!-- 2. Last Name（必填） -->
                <label style="width: 380px;">{{ langMap.labels.lastName[currentLang] }}</label>
                <input 
                    class="fsb_inpu" 
                    v-model="form.lastName" 
                    type="text" 
                    :class="{ error: errors.lastName }"
                    @input="clearError('lastName')"
                    :placeholder="langMap.placeholders.lastName[currentLang]"
                />
                <div class="error-tip" v-if="errors.lastName">{{ langMap.tips.pleaseWrite[currentLang] }}</div>

                <!-- 3. Email（必填） -->
                <label style="width: 380px;">{{ langMap.labels.email[currentLang] }}</label>
                <input 
                    class="fsb_inpu" 
                    v-model="form.email" 
                    type="email" 
                    :class="{ error: errors.email }"
                    @input="clearError('email')"
                    :placeholder="langMap.placeholders.email[currentLang]"
                />
                <div class="error-tip" v-if="errors.email">{{ langMap.tips.pleaseWrite[currentLang] }}</div>

                <!-- 4. Phone（必填） -->
                <label style="width: 380px;">{{ langMap.labels.phone[currentLang] }}</label>
                <input 
                    class="fsb_inpu" 
                    v-model="form.phone" 
                    type="tel" 
                    :class="{ error: errors.phone }"
                    @input="clearError('phone')"
                    :placeholder="langMap.placeholders.phone[currentLang]"
                />
                <div class="error-tip" v-if="errors.phone">{{ langMap.tips.pleaseWrite[currentLang] }}</div>

                <!-- 5. Segment of Interest（必填-单选） -->
                <label style="width: 380px;">{{ langMap.labels.segment[currentLang] }}</label>
                <div 
                    class="fsb_radio_group" 
                    :class="{ error: errors.segment }"
                >
                    <div class="fsb_radio">
                        <input type="radio" id="yacht" value="yacht" v-model="form.segment" @change="clearError('segment')" />
                        <label for="yacht">{{ langMap.segmentOptions.yacht[currentLang] }}</label>
                    </div>
                    <div class="fsb_radio">
                        <input type="radio" id="boat-house" value="boat-house" v-model="form.segment" @change="clearError('segment')" />
                        <label for="boat-house">{{ langMap.segmentOptions.boatHouse[currentLang] }}</label>
                    </div>
                    <div class="fsb_radio">
                        <input type="radio" id="indoor" value="indoor" v-model="form.segment" @change="clearError('segment')" />
                        <label for="indoor">{{ langMap.segmentOptions.indoor[currentLang] }}</label>
                    </div>
                    <div class="fsb_radio">
                        <input type="radio" id="outdoor" value="outdoor" v-model="form.segment" @change="clearError('segment')" />
                        <label for="outdoor">{{ langMap.segmentOptions.outdoor[currentLang] }}</label>
                    </div>
                </div>
                <div class="error-tip" v-if="errors.segment">{{ langMap.tips.pleaseWrite[currentLang] }}</div>

                <!-- 6. Country of Residence（必填） -->
                <label style="width: 380px;">{{ langMap.labels.country[currentLang] }}</label>
                <input 
                    class="fsb_inpu" 
                    v-model="form.country" 
                    type="text" 
                    :class="{ error: errors.country }"
                    @input="clearError('country')"
                    :placeholder="langMap.placeholders.country[currentLang]"
                />
                <div class="error-tip" v-if="errors.country">{{ langMap.tips.pleaseWrite[currentLang] }}</div>

                <!-- 7. Nationality（必填） -->
                <label style="width: 380px;">{{ langMap.labels.nationality[currentLang] }}</label>
                <input 
                    class="fsb_inpu" 
                    v-model="form.Nationality" 
                    type="text" 
                    :class="{ error: errors.Nationality }"
                    @input="clearError('Nationality')"
                    :placeholder="langMap.placeholders.nationality[currentLang]"
                />
                <div class="error-tip" v-if="errors.Nationality">{{ langMap.tips.pleaseWrite[currentLang] }}</div>

                <!-- 8. Message（必填） -->
                <label style="width: 380px;">{{ langMap.labels.message[currentLang] }}</label>
                <textarea 
                    style="width: 360px;height: 120px;" 
                    v-model="form.message" 
                    :class="{ error: errors.message }"
                    @input="clearError('message')"
                    :placeholder="langMap.placeholders.message[currentLang]"
                ></textarea>
                <div class="error-tip" v-if="errors.message">{{ langMap.tips.pleaseWrite[currentLang] }}</div>

                <!-- 9. 隐私协议（必填-复选） -->
                <div class="fsb_checkbox">
                    <input 
                        style="margin-right: 10px;" 
                        v-model="form.agreePersonal" 
                        type="checkbox" 
                        id="agreePersonal"
                        :class="{ error: errors.agreePersonal }"
                        @change="clearError('agreePersonal')"
                    />
                    <label class="fsb_check_font" for="agreePersonal">{{ langMap.agreements.personal[currentLang] }}</label>
                </div>
                <div class="error-tip" v-if="errors.agreePersonal">{{ langMap.tips.pleaseWrite[currentLang] }}</div>

                <!-- 10. 电话授权（必填-复选） -->
                <div class="fsb_checkbox">
                    <input 
                        style="margin-right: 10px;" 
                        v-model="form.agreePhone" 
                        type="checkbox" 
                        id="agreePhone"
                        :class="{ error: errors.agreePhone }"
                        @change="clearError('agreePhone')"
                    />
                    <label class="fsb_check_font" for="agreePhone">{{ langMap.agreements.phone[currentLang] }}</label>
                </div>
                <div class="error-tip" v-if="errors.agreePhone">{{ langMap.tips.pleaseWrite[currentLang] }}</div>

                <button type="submit" class="fsb_submit">{{ langMap.buttons.submit[currentLang] }}</button>
                <div class="fsb_check_font">{{ langMap.footerDesc[currentLang] }}</div>
            </form>
        </div>
        <bottom-text></bottom-text>
    </div>
</template>

<script>
import { formgo } from '../../request/api.js'
import bottomText from './bottomText.vue';

export default {
    components: {
        bottomText
    },
    name: 'FormSubmit',
    data() {
        return {
            form: {
                firstName: '',
                lastName: '',
                email: '',
                phone: '',
                segment: '',
                country: '',
                message: '',
                Nationality: '',
                agreePersonal: false,
                agreePhone: false,
                isMobile: 0
            },
            errors: {}, 
            showSuccessTip: false,
            // 2. 新增：当前语言状态（默认英文，与表单初始一致）
            currentLang: 'en',
            // 3. 新增：语言映射表（所有需要翻译的文本都在这里定义）
            langMap: {
                title: {
                    en: 'Make an Enquiry',
                    zh: '提交咨询'
                },
                subtitle: {
                    en: 'If you are ready to take the next step and would like to speak to an official CHOISI representative，please complete the form below. One of our representatives will then contact you to discuss your enquiry and help you find your perfect products. We look forward to helping you on the next chapter of your unique CHOISI journey.',
                    zh: '若您已准备好迈出下一步，并希望与CHOISI官方代表沟通，请填写下方表单。我们的代表将尽快与您联系，探讨您的需求并协助您找到合适的产品。期待在您独特的CHOISI旅程中为您提供支持。'
                },
                labels: {
                    firstName: { en: '* First Name', zh: '* 名' },
                    lastName: { en: '* Last Name', zh: '* 姓' },
                    email: { en: '* Email', zh: '* 电子邮箱' },
                    phone: { en: 'Phone', zh: '电话' },
                    segment: { en: '* Segment of Interest', zh: '* 感兴趣领域' },
                    country: { en: '* Country of Residence', zh: '* 居住国家' },
                    nationality: { en: 'Nationality', zh: '国籍' },
                    message: { en: '* Message', zh: '* 留言内容' }
                },
                placeholders: {
                    firstName: { en: 'Enter your first name', zh: '请输入您的名' },
                    lastName: { en: 'Enter your last name', zh: '请输入您的姓' },
                    email: { en: 'Enter your email', zh: '请输入您的电子邮箱' },
                    phone: { en: 'Enter your phone number', zh: '请输入您的电话号码' },
                    country: { en: 'Enter your country of residence', zh: '请输入您的居住国家' },
                    nationality: { en: 'Enter your nationality', zh: '请输入您的国籍' },
                    message: { en: 'Enter your message', zh: '请输入您的留言' }
                },
                segmentOptions: {
                    yacht: { en: 'Yacht', zh: '游艇' },
                    boatHouse: { en: 'Boat House', zh: '船屋' },
                    indoor: { en: 'Indoor', zh: '室内' },
                    outdoor: { en: 'Outdoor', zh: '室外' }
                },
                agreements: {
                    personal: {
                        en: 'I agree CHOISI may use my personal data to send me personalized marketing material in accordance with the Privacy Policy.',
                        zh: '我同意CHOISI可根据隐私政策，使用我的个人数据向我发送个性化营销资料。'
                    },
                    phone: {
                        en: 'I have read and understood the CHOISI Privacy Policy (please click on the link at the bottom of this inquiry form) *, and agree to CHOISI using and sharing my personal data for the above purposes',
                        zh: '我已阅读并理解CHOISI隐私政策（请点击咨询表单底部链接）*，同意CHOISI为上述目的使用和共享我的个人数据。'
                    }
                },
                footerDesc: {
                    en: 'We process personal data in accordance with the terms of our privacy policy, which can be obtained here: choisivip@163.com. If you wish to withdraw your consent, please contact us via email CHOISIVIP@163.COM',
                    zh: '我们将根据隐私政策条款处理个人数据，政策详情可通过此邮箱获取：choisivip@163.com。若您希望撤回同意，请通过邮箱CHOISIVIP@163.COM与我们联系。'
                },
                buttons: {
                    submit: { en: 'Submit', zh: '提交' }
                },
                tips: {
                    pleaseWrite: { en: 'please write', zh: '请填写' }
                },
                successText: {
                    en: 'Form submitted successfully!',
                    zh: '表单提交成功！'
                },
                successDesc: {
                    en: 'Our representative will contact you soon.',
                    zh: '我们的代表将尽快与您联系。'
                }
            }
        }
    },
    mounted() {this.isMobile = localStorage.getItem('isMobile')
        // 初始化：从localStorage读取语言状态（与之前的lang逻辑保持一致）
        const storedLang = JSON.parse(localStorage.getItem('Lang'));
        window.addEventListener('langChange', () => {
            this.syncLangFromStorage();
        });
        if (storedLang?.fyType === 2) {
            this.currentLang = 'en';
        } else if (storedLang?.fyType === 1) {
            this.currentLang = 'zh';
        }
    },
    methods: {
        syncLangFromStorage() {
            this.currentLang = JSON.parse(localStorage.getItem('Lang')).fyType === 2 ? 'en' : 'zh'
        },
        clearError(field) {
            this.errors[field] = false;
        },

        validateForm() {
            const errors = {};
            const { form } = this;

            if (!form.firstName.trim()) errors.firstName = true;
            if (!form.lastName.trim()) errors.lastName = true;
            if (!form.email.trim()) errors.email = true;
            if (!form.phone.trim()) errors.phone = true;
            if (!form.country.trim()) errors.country = true;
            if (!form.Nationality.trim()) errors.Nationality = true;
            if (!form.message.trim()) errors.message = true;
            if (!form.segment) errors.segment = true;
            if (!form.agreePersonal) errors.agreePersonal = true;
            if (!form.agreePhone) errors.agreePhone = true;

            this.errors = errors;
            return Object.keys(errors).every(key => !errors[key]);
        },

        submitForm() {
            const isFormValid = this.validateForm();
            if (!isFormValid) return;

            const submitData = {
                first_name: this.form.firstName,
                last_name: this.form.lastName,
                email: this.form.email,   
                phone: this.form.phone,
                interested_part: this.form.segment,
                country: this.form.country,
                nationality: this.form.Nationality,
                content: this.form.message,
            };

            formgo(submitData)
                .then(res => {
                    console.log('提交成功返回数据：', res);
                    this.showSuccessTip = true;
                    setTimeout(() => {
                        this.showSuccessTip = false;
                    }, 3000);
                    // 重置表单时同步清空语言相关的输入（避免残留）
                    this.form = { 
                        firstName: '', lastName: '', email: '', phone: '', segment: '', 
                        country: '', message: '', Nationality: '', 
                        agreePersonal: false, agreePhone: false 
                    };
                    this.errors = {};
                })
                .catch(err => {
                    console.error('提交失败错误信息：', err);
                    alert(this.currentLang === 'en' ? 'Submit failed, please try again!' : '提交失败，请重试！');
                });
        },

        // 4. 新增：切换语言方法（同步更新localStorage）
        toggleLang() {
            this.currentLang = this.currentLang === 'en' ? 'zh' : 'en';
            // 更新localStorage的Lang状态（与之前的逻辑保持一致）
            localStorage.setItem('Lang', JSON.stringify({
                fyType: this.currentLang === 'en' ? 2 : 1
            }));
        }
    }
}
</script>

<style>
.fsb {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
    position: relative;
    /* 给悬浮按钮留出空间，避免遮挡表单底部 */
    padding-bottom: 80px;
}
.fsb_mobile{
    height: 78%;
}
/* 5. 新增：悬浮翻译按钮样式（右下角固定，贴合主题色） */
.translate-btn {
    position: fixed;
    right: 40px;
    bottom: 40px;
    width: 120px;
    height: 44px;
    line-height: 44px;
    text-align: center;
    background-color: #6488C6;
    color: #fff;
    font-size: 16px;
    font-weight: 500;
    border-radius: 22px;
    box-shadow: 0 4px 12px rgba(100, 136, 198, 0.3);
    cursor: pointer;
    transition: background-color 0.3s ease;
    z-index: 9998; /* 低于成功弹窗，不遮挡提示 */
}
.translate-btn:hover {
    background-color: #5577b9; /* hover加深，与提交按钮交互一致 */
}

/* 成功提示弹窗样式 */
.success-tip {
    position: fixed;
    top: 50%;
    left: 38%;
    transform: translate(-50%, -50%);
    background: #fff;
    padding: 40px 60px;
    border-radius: 8px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
    text-align: center;
    z-index: 9999;
    animation: fadeIn 0.5s ease-out forwards;
}
.success-icon {
    font-size: 48px;
    color: #6488C6;
    margin-bottom: 15px;
}
.success-text {
    font-size: 24px;
    font-weight: 600;
    color: #021131;
    margin-bottom: 8px;
}
.success-desc {
    font-size: 16px;
    color: #666;
}

.fsb_box {
    max-width: 71%;
    margin: 60px auto;
}
.fsb_box_mobile{
    margin: 10px auto;
    max-width: 92%;
}
.fsb_title {
    font-family: PingFang SC, PingFang SC;
    font-weight: 600;
    font-size: 52px;
    color: #021131;
    line-height: 52px;
    text-align: center;
    margin-bottom: 40px;
}
.fsb_title_mobile{
    font-size: 26px;margin-bottom: 10px;
}
.fsb_small_title {
    width: 1200px;
    height: auto; /* 修复原固定高度导致中文换行溢出问题 */
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 18px;
    color: #021131;
    line-height: 26px; /* 中文行高调整，提升可读性 */
    text-align: center;
    margin-bottom: 40px;
    white-space: normal; /* 允许中文换行 */
}
.fsb_small_title_mobile{
    text-align: left;
    width: 100%;
    margin-bottom: 15;
}
.fsb_form {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.fsb_inpu {
    width: 360px;
    height: 30px;
    border-radius: 0px 0px 0px 0px;
    border: 1px solid #6488C6;
}

.fsb_form label {
    font-size: 16px;
    color: #021131;
    margin-bottom: 10px;
}

.fsb_form input,
.fsb_form select,
.fsb_form textarea {
    padding: 10px;
    margin-bottom: 20px;
    border: 1px solid #6488C6;
    border-radius: 4px;
    font-size: 16px;
}

.fsb_form textarea {
    height: 100px;
}

/* 勾选框与文字顶部对齐 */
.fsb_checkbox {
    display: flex;
    align-items: flex-start;
    margin-bottom: 10px;
}
/* 勾选框样式（颜色#6488C6） */
.fsb_checkbox input {
    margin-right: 10px;
    margin-top: 2px;
    appearance: none;
    width: 20px;
    height: 20px;
    border: 1px solid #6488C6;
    border-radius: 3px;
    position: relative;
    cursor: pointer;
}
.fsb_checkbox input:checked::before {
    content: '✓';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: #fff;
    font-size: 14px;
    font-weight: 600;
}
.fsb_checkbox input:checked {
    background-color: #6488C6;
    border-color: #6488C6;
}
/* 错误状态勾选框 */
.fsb_checkbox input.error {
    border-color: #ff4444 !important;
}
.fsb_checkbox input.error:checked {
    background-color: #ff4444 !important;
    border-color: #ff4444 !important;
}

.fsb_check_font {
    width: 334px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #021131;
    line-height: 22px;
}

.fsb_privacy {
    font-size: 14px;
    color: #666;
    margin-bottom: 20px;
}

.fsb_submit {
    width: 360px;
    height: 38px;
    background: #6488C6;
    border-radius: 0px 0px 0px 0px;
    line-height: 38px;
    text-align: center;
    font-family: PingFang SC, PingFang SC;
    font-weight: 600;
    font-size: 18px;
    color: #FFFFFF;
    border: 0px;
    margin-bottom: 30px;
    cursor: pointer;
}

.fsb_submit:hover {
    background-color: #5577b9;
}

.fsb_radio_group {
    display: flex;
    flex-direction: column;
    margin-bottom: 20px;
}

.fsb_radio {
    width: 370px;
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    font-size: 16px;
    color: #021131;
}

.fsb_radio input {
    margin-right: 10px;
    appearance: none;
    width: 20px;
    height: 20px;
    border: 1px solid #999999;
    border-radius: 50%;
    position: relative;
}

.fsb_radio input:checked::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 10px;
    height: 10px;
    background-color: #021131;
    border-radius: 50%;
}

/* 浮现动画样式 */
@keyframes fadeIn {
    from {
        opacity: 0;
        transform: translateY(20px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.animate-fade-in {
    opacity: 0;
    animation: fadeIn 0.8s ease-out forwards;
}

.fsb_title {
    animation-delay: 0s;
}

.fsb_small_title {
    animation-delay: 0.3s;
}

.fsb_form {
    animation-delay: 0.6s;
}

/* 未填写项错误提示样式 */
.fsb_inpu.error,
.fsb_form textarea.error,
.fsb_form .fsb_radio_group.error input[type="radio"] {
    border-color: #ff4444;
}
.error-tip {
    position: relative;
    top: -15px;
    left: 0;
    font-size: 14px;
    color: #ff4444;
    margin-bottom: 10px;
    text-align: left;
    width: 360px;
}
</style>